import React, { MouseEvent, PropsWithChildren } from 'react'
import { Box, Theme, useMediaQuery } from '@mui/material'
import { Sidebar } from 'components/Navbars/Sidebar'
import { HeaderNavbar } from 'components/Navbars/HeaderNavbar'
import { dashboardBoxStyle } from './styles'
import { useDashboard } from 'store/DashboardContext'
import { useRouteMatch } from 'react-router-dom'

export const DashboardLayout: React.FC<PropsWithChildren> = ({ children }) => {
  const {
    state: { isSideNavOpen },
    actions: { toggleSideNav }
  } = useDashboard()

  const mobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('lg'))
  const handleOverlay = (e: MouseEvent<HTMLDivElement>): void => {
    if (!isSideNavOpen && mobile && e.target === e.currentTarget) {
      toggleSideNav()
    }
  }
  const match = useRouteMatch('/dashboard/test/:id')

  if (match) {
    return <>{children}</>
  }

  return (
    <Box
      sx={(theme) => ({
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: 'flex',
        position: 'absolute',
        flexDirection: 'column',
        justifyContent: 'space-between',
        contain: 'layout size style',
        backgroundColor: theme.palette.background.default
        // [theme.breakpoints.down('lg')]: {
        //   backgroundColor: theme.palette.white.main
        //   //   overflow: !isSideNavOpen ? 'hidden' : 'auto',
        //   //   height: !isSideNavOpen ? '100vh' : 'auto'
        // }
      })}
    >
      <HeaderNavbar />
      <Box
        sx={(theme) => ({
          display: 'flex',
          width: '100%',
          height: '100%',
          gap: theme.spacing(2)
        })}
      >
        <Sidebar />
        <Box
          className="main"
          sx={(theme) => ({
            flexGrow: 1,
            position: 'relative'
          })}
        >
          <Box
            sx={(theme) => dashboardBoxStyle(theme, isSideNavOpen)}
            onClick={handleOverlay}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
